import { ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from './../../components/shared.module';

import { JsonPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { HighlightJsModule, HighlightJsService } from 'angular2-highlight-js';
import { ConfigurationsComponent } from './configurations.component';

@NgModule({
    declarations: [
        ConfigurationsComponent
    ],
    imports: [
        BrowserModule,
        TranslateModule,
        FormsModule,
        HighlightJsModule,
        SharedModule
    ],
    exports: [ConfigurationsComponent]
})

export class SuperAdminModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: SuperAdminModule,
            providers: [
                HighlightJsService,
                JsonPipe
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/views/superadmin/superadmin.module.ts